import { createContext, useContext, useMemo, type PropsWithChildren } from 'react';
import type { AttachmentAdapter, EditComposerRuntime, ThreadRuntime } from '@assistant-ui/react';
import { createMessageRepair } from './message-repair';

const RepairContext = createContext<((composer: EditComposerRuntime) => Promise<void>) | null>(
  null,
);
export const useMessageRepair = () => useContext(RepairContext);
export function MessageRepairProvider({
  children,
  enabled,
  threadId,
  thread,
  attachments,
  isCurrentOwner,
}: PropsWithChildren<{
  enabled: boolean;
  threadId: string;
  thread: ThreadRuntime;
  attachments: AttachmentAdapter;
  isCurrentOwner: () => boolean;
}>) {
  const save = useMemo(
    () =>
      createMessageRepair({
        threadId,
        thread,
        attachments,
        isCurrentOwner,
        selected: () => {},
      }),
    [threadId, thread, attachments, isCurrentOwner],
  );
  return <RepairContext.Provider value={enabled ? save : null}>{children}</RepairContext.Provider>;
}
